const ENDPOINT_MY_CENTERS = '/secure/me/centers'
const ENDPOINT_CENTER = '/secure/centers/:centerId'
const ENDPOINT_CENTER_CREATE = '/secure/centers'
const ENDPOINT_ENABLE_NOTIFICATION =
  '/secure/centers/:centerId/enable-notification/:codeNotif'
const ENDPOINT_DISABLE_NOTIFICATION =
  '/secure/centers/:centerId/disable-notification/:codeNotif'

export const state = () => ({
  myCenters: [],
  myCurrentCenter: '',
  centerToken: false
})

export const mutations = {
  setMyCenters(state, payload) {
    state.myCenters = payload
  },

  setMyCurrentCenter(state, payload) {
    state.myCurrentCenter = payload
  },
  setCenterToken(state, payload) {
    state.centerToken = payload
  }
}

export const getters = {
  getMyCenters(state) {
    return state.myCenters
  },
  getMyCurrentCenter(state) {
    return state.myCurrentCenter
  },
  getCenterToken(state) {
    return state.centerToken
  }
}

export const actions = {
  async fetchMyCenters({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(`${ENDPOINT_MY_CENTERS}`)
      //      console.log(response)
      commit('setMyCenters', response.data)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async createCenter({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_CENTER_CREATE, payload)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deleteCenter({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_CENTER.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updateCenter({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_CENTER.replace(':centerId', payload.centerId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async centerEnableNotification({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_ENABLE_NOTIFICATION.replace(
          ':centerId',
          payload.centerId
        ).replace(':codeNotif', payload.codeNotif)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async centerDisableNotification({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.patch(
        ENDPOINT_DISABLE_NOTIFICATION.replace(
          ':centerId',
          payload.centerId
        ).replace(':codeNotif', payload.codeNotif)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
